import type { Client } from "@/data/models/Client";

/**
 * Whether an address is one of the placeholder mail addresses a client is created with:
 * a purely numeric local part on the IRES domain, e.g. `10321@ires.de`.
 */
export function isEmailAddressOfNewClient(emailAddress?: string | null) {
  if (!emailAddress) {
    return false;
  }

  const tokens = emailAddress.split("@");

  if (tokens.length < 2) {
    return false;
  }

  return tokens[0] !== "" && !isNaN(Number(tokens[0])) && tokens[1] === "ires.de";
}

/**
 * Whether the client has to be prompted to replace the placeholder credentials it was created
 * with.
 *
 * Administrator (master) clients are excluded: they exist to hold a group's configuration and are
 * reached through the member-client switch, not by signing in with their own placeholder
 * credentials. Prompting them means the dialog reappears on every client snapshot with nobody able
 * to complete it. Changing the address stays available in the settings page.
 */
export function mustChangePlaceholderCredentials(client: Client) {
  if (client.hasAdministrationCapabilities === true) {
    return false;
  }

  return isEmailAddressOfNewClient(client.email);
}
